import Decimal            from 'decimal.js';
import Numeric            from '@/core/types/Numeric';
import Title_ru_RU_Class  from "@/core/misc/decorators/Title_ru_RU_Class";

/**
 * Множитель единицы измерения: сколько базовых единиц в одной единице ЭТП.
 * В декалитре 10 литров, в тысяче штук 1000 штук.
 *
 * SCALE = 0 — множитель целый. Дробных единиц измерения не бывает: единица
 * либо укрупняет базовую в целое число раз, либо совпадает с ней (множитель 1).
 *
 * Отдельный тип, а НЕ Multiplier, хотя оба «на что умножить». У Multiplier
 * внутреннее представление и внешнее различаются: внутри 1.19, снаружи процент
 * 19, и граница между ними — fromServer/toJSON. У множителя единиц такого
 * различия нет и быть не может, 1000 — это 1000 на обоих концах. Пока поле
 * лежало в Multiplier, одна и та же единица давала разные числа в зависимости
 * от пути создания: инициализатор поля звал конструктор напрямую и получал 1,
 * а initDefault шёл через гидрацию и получал 1.01.
 *
 * Никаких операций на типе нет намеренно: пересчёт количеств и цен — в
 * UnitsUtils, там же обе стороны перехода.
 *
 * Зеркальный бекенд: core/types/QtyMultiplier.php на BcMath\Number.
 */
@Title_ru_RU_Class('Множитель единицы измерения')
class QtyMultiplier extends Numeric {
    protected static readonly SCALE = 0;

    static fromServer(value: string): QtyMultiplier {
        return new QtyMultiplier(value);
    }

    /** Результат вычисления — уже посчитанный Decimal. */
    static fromOperation(value: Decimal): QtyMultiplier {
        return new QtyMultiplier(value);
    }
}

export default QtyMultiplier;